import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { JSR310ConversionService } from '../../../../shared/jsr310-localdates/services/jsr310-conversion.service';

import { SimplifiedTransfert } from '../entities/simplified-transfert.entity';
import { TransfertResponsabiliteOrder } from "../entities/transfert-responsabilite-order.entity";
import { TransfertResponsabiliteTLR } from "../entities/transfert-responsabilite-tlr.entity";

@Injectable({ providedIn: 'root' })
export class TransfertResponsabiliteService {
	private path: string;

	constructor( //
		@Inject(HttpClient) public httpClient: HttpClient, //
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService, 
		@Optional() @SkipSelf() previousInstance?: TransfertResponsabiliteService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}
	
	public askTransfert(command: TransfertResponsabiliteOrder): Observable<void> {
		let url = this.path + 'transfert-responsabilite/transfert-orders';
		return this.httpClient //
			.post<void>(url, command) //
			;
	}

	public transfertsEnCours(): Observable<SimplifiedTransfert[]> {
		let url = this.path + 'transfert-responsabilite/en_cours';
		return this.httpClient //
			.get<SimplifiedTransfert[]>(url) //
			;
	}

	public accepterTransfert(transfertId: number, uidUser: string): Observable<any> {
		let url = this.path + 'transfert-responsabilite/end/' + transfertId + "/user/" + uidUser;
		return this.httpClient //
			.put<any>(url, {}) //
			;
	};

	public refusStep2(transfertId: number, uidUser: string): Observable<any> {
		let url = this.path + 'transfert-responsabilite/nack/' + transfertId + "/user/" + uidUser;
		return this.httpClient //
			.put<any>(url, {}) //
			;
	};

	public annulerTransfert(transfertId: number): Observable<void> {
		let now = this.conversionService.toLocalDateTime(new Date());
		let url = this.path + 'transfert-responsabilite/cancel/' + transfertId;
		return this.httpClient //
			.put<void>(url, {'timestamp': now}) //
			;
	}

	public fermer(transfertId: number, uidUser: string): Observable<any> {
		let url = this.path + 'transfert-responsabilite/close/' + transfertId + "/user/" + uidUser;
		return this.httpClient //
			.put<any>(url, {}) //
			;
	};

	// Fonction de recuperation histo transfert
	public getTransferts(): Observable<SimplifiedTransfert[]> {
		let url = this.path + "transfert-responsabilite/historique-transferts";
		let result = this.httpClient.get<SimplifiedTransfert[]>(url);
		return result;
	}

	// Fonction export histo transfert
	public export(): Observable<Blob> {
		let url = this.path + 'transfert-responsabilite/export';
		return this.httpClient.get(url, { responseType: 'blob' });
	}
}